import { connect, MapDispatchToProps, MapStateToProps } from 'react-redux';
import { Props } from './FolderBar';
import {
  unsetSelectedFolderId,
  pauseCurrentFolderDeviationFetching,
} from '../../../../actions/gallectionSection';
import { AppState } from '../../../../../types/store';
import {
  getCurrentlyViewedFolderId,
  getGallectionSectionType,
} from '../../../../selectors/gallectionSection';
import { getFolderById } from '../../../../selectors/folders';

type StateProps = Pick<Props, 'currentFolder'>;
type DispatchProps = Pick<
  Props,
  'unsetSelectedFolderId' | 'pauseCurrentFolderDeviationFetching'
>;
export type OwnProps = Omit<Props, keyof DispatchProps>;

const mapStateToProps: MapStateToProps<StateProps, OwnProps, AppState> = (
  state,
  ownProps
) => {
  const currentlyViewedFolderId = getCurrentlyViewedFolderId(state);
  const currentFolder =
    ownProps.currentFolder ||
    (typeof currentlyViewedFolderId === 'number'
      ? getFolderById(
          state,
          getGallectionSectionType(state),
          currentlyViewedFolderId
        )
      : undefined);

  return { currentFolder };
};
const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = {
  unsetSelectedFolderId,
  pauseCurrentFolderDeviationFetching,
};

export default connect(mapStateToProps, mapDispatchToProps);
